export default __webpack_public_path__ + "static/media/cal-icon-white.e889c6bb.svg";